import { DocItem } from 'src/@types/docs';
import Iconify from 'src/components/iconify';

export const DocsExplorerLabel = ({ doc }: { doc: DocItem }) => {
  return (
    <>
      {doc.icon ? (
        <em-emoji shortcodes={doc.icon.value} />
      ) : (
        <Iconify icon="tabler:file-description" />
      )}
      <span>{doc.title}</span>
    </>
  );
};
